import styled from 'styled-components';
import Select from 'react-select';

import { ErrorText, Label } from '@/shared/ui/form/phone-field/styles';

const Wrapper = styled.div`
  width: 100%;
  z-index: 100;

  .select-countries {
    ${({ $error }) => $error && `border: 1px solid #da4444;`}
    ${({ $valide }) => $valide && `border: 1px solid #08AD5E;`}
    border-radius: 8px;
  }

  .select__control {
    border: none;
    padding: 6px;
    gap: 8px;
    border-radius: 8px;
    background: #4b444c;
    color: #afafaf;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    border: transparent;
    box-shadow: none;
  }

  .select__indicators {
    &:hover {
      color: hsl(0, 0%, 100%);
    }
  }

  .select__single-value {
    color: #afafaf;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }

  .select__input-container {
    color: #afafaf;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }

  .select__menu {
    border: none;
    background: #4b444c;
  }

  .select__option {
    background: #4b444c;

    &:active {
      background: rgb(39, 38, 43);
    }

    &:hover {
      background: rgb(98, 90, 99);
    }
  }
`;

const StyledSelect = styled(Select).attrs({
  className: 'select-countries',
  classNamePrefix: 'select',
})``;

export { Wrapper, StyledSelect, ErrorText, Label };
